<!-- TEMPLATE -->
<template>
    <v-app id="inspire">
        <v-navigation-drawer v-model="drawer" dark app>
            <v-layout column fill-height>
                <v-flex xs12>
                    <v-list color="white" dense expand>
                        <!-- <router-link to="/"> -->
                        <v-list-tile dark to="/">
                            <v-list-tile-content>
                                <v-list-tile-title color="white">Last Games</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <!-- </router-link> -->
                        <v-list-group v-for="(tournament, tName) in tournaments" :key="tName">
                            <v-list-tile slot="activator">
                                <v-list-tile-title>{{tournament.name}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-group v-for="(splits, year) in tournament.years" :key="tName+year">
                                <v-list-tile slot="activator">
                                    <v-list-tile-title>{{year}}</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-for="split in splits" :to="'/tournament/' + tName + '/' + year + '/' + split" :key="tName+year+split">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{split}}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list-group>
                        </v-list-group>
                    </v-list>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs12>
                    <v-layout class="bottom-links" column justify-end fill-height>
                        <a class="patreon-link" href="https://www.patreon.com/GuySake">Become a Sponsor</a>
                        <!-- <a class="patreon-link" href="https://www.patreon.com/GuySake">Silver Sponsor</a>
                        <a class="patreon-link" href="https://www.patreon.com/GuySake">Silver Sponsor</a>
                        <a class="patreon-link" href="https://www.patreon.com/GuySake">Silver Sponsor</a>
                        <a class="patreon-link" href="https://www.patreon.com/GuySake">Silver Sponsor</a> -->
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-navigation-drawer>
        <router-view>
            <v-toolbar-side-icon slot="toolbar-icon" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <template slot="toolbar-links">
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn href="https://twitter.com/GuySake" flat>Twitter</v-btn>
                    <v-btn href="https://www.patreon.com/GuySake" flat>Patreon</v-btn>
                    <v-btn href="https://www.patreon.com/GuySake" flat>Become a Sponsor</v-btn>
                </v-toolbar-items>
            </template>
        </router-view>
        <!-- <Region transition="fade-transition">
            <v-toolbar-side-icon slot="toolbar-icon" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <template slot="toolbar-links">
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn flat>Twitter</v-btn>
                    <v-btn flat>Patreon</v-btn>
                    <v-btn flat>Sponsored Link</v-btn>
                </v-toolbar-items>
            </template>
        </Region> -->
        <!-- <v-footer color="primary" fixed app>
            <span class="white--text">&copy; 2019</span>
        </v-footer> -->
    </v-app>
</template>
<!-- SCRIPT -->
<script>
import Region from "./components/Region.vue"

export default {
    name: "app",
    components: {
        Region
    },
    data: function() {
        return {
            drawer: null,
            tournaments: {
                LEC: {
                    name: 'LEC',
                    years: {
                        '2018': ['summer', 'spring'],
                        '2019': ['spring']
                    }
                },
                'NALCS': {
                    name: 'LCS',
                    years: {
                        '2018': ['summer', 'spring'],
                        '2019': ['spring']
                    }
                },
                'LCK': {
                    name: 'LCK',
                    years: {
                        '2018': ['summer', 'spring'],
                        '2019': ['spring']
                    }
                },
                'WORLDS': {
                    name: 'International',
                    years: {
                        '2018': ['worlds']
                    }
                }
            }
        }
    }
}
</script>
<!-- STYLE -->
<style scoped>
.center-loader {
    margin: auto;
}

a,
a.primary--text {
    color: white !important;
    text-decoration: none;
}

a.patreon-link {
    text-align: center;
    color: grey !important;
}

.bottom-links {
    padding-bottom: 5px;
}
</style>